import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { BaseRequestPolicy } from "./requestPolicy";
/**
 * Creates a policy that signs outgoing requests by calling to the provided `authenticationProvider`'s `signRequest` method.
 * @param authenticationProvider - The authentication provider.
 * @returns An instance of the {@link SigningPolicy}.
 */

export function signingPolicy(authenticationProvider) {
  return {
    create: function create(nextPolicy, options) {
      return new SigningPolicy(nextPolicy, options, authenticationProvider);
    }
  };
}
/**
 * A policy that signs outgoing requests by calling to the provided `authenticationProvider`'s `signRequest` method.
 */

export var SigningPolicy = /*#__PURE__*/function (_BaseRequestPolicy) {
  _inherits(SigningPolicy, _BaseRequestPolicy);

  var _super = _createSuper(SigningPolicy);

  function SigningPolicy(nextPolicy, options, authenticationProvider) {
    var _this;

    _classCallCheck(this, SigningPolicy);

    _this = _super.call(this, nextPolicy, options);
    _this.authenticationProvider = authenticationProvider;
    return _this;
  }

  _createClass(SigningPolicy, [{
    key: "signRequest",
    value: function signRequest(request) {
      return this.authenticationProvider.signRequest(request);
    }
  }, {
    key: "sendRequest",
    value: function sendRequest(request) {
      var _this2 = this;

      return this.signRequest(request).then(function (nextRequest) {
        return _this2._nextPolicy.sendRequest(nextRequest);
      });
    }
  }]);

  return SigningPolicy;
}(BaseRequestPolicy);